module.exports = __webpack_public_path__ + "static/media/047-mobile-shop.478ae534.svg";